import React, { useState } from 'react'
import { AppLayout } from 'layouts'
import {
    Box,
    Link,
    Typography,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper,
    Tabs,
    Tab,
    List,
    ListItem,
    ListItemText,
} from '@mui/material'
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf'

const tabLabelSx = {
    fontFamily: 'Poppins-Semibold',
    fontSize: { xs: '13px', md: '15px' },
    textTransform: 'uppercase',
    minHeight: 48,
}

const cellSx = {
    fontFamily: 'Poppins-Regular',
    fontSize: '14px',
}

const headCellSx = {
    fontFamily: 'Poppins-Semibold',
    fontSize: '14px',
    fontWeight: 'bold',
}

const statusColor = (status) => {
    if (status === 'Published') return '#4caf50'
    if (status === 'Accepted') return '#2196f3'
    if (status === 'Submitted') return '#ff9800'
    return '#666'
}

const publicationSections = [
    {
        title: 'Submitted',
        papers: [
            {
                id: 1,
                authors: 'Ishtiaque Ahmed, Haris Parvaiz, Leila Musavian',
                paper: 'Waveguide to Meaning: Semantic-Aware NOMA for Pinching-Antenna Systems',
                venue: 'Submitted to IEEE Transactions on Communications, April 2026.',
                status: 'Submitted',
                link: 'https://arxiv.org/abs/2604.05464',
            },
            {
                id: 2,
                authors: 'Yingzhuo Sun, Yulan Gao, Ming Xiao, Zhu Han, Octavia A. Dobre',
                paper: 'Visibility-aware Satellite Selection and Resource Allocation in Multi-Orbit LEO Networks',
                venue: 'Submitted to IEEE Transactions on Communications.',
                status: 'Submitted',
                link: 'https://arxiv.org/abs/2511.12678',
            },
            {
                id: 3,
                authors: 'Ayesha Jadoon, H. R. Chi, D. Corujo, R. L. Aguiar, F. J. Ferrão',
                paper: 'Energy- and Cost-Efficient Healthcare Task Offloading via Network Edge Digital Twin',
                venue: 'Submitted to MDPI Sensors, June 2026.',
                status: 'Submitted',
                link: '#',
            },
        ],
    },
    {
        title: '2026',
        papers: [
            {
                id: 4,
                authors: 'Purna Sai Garigipati, Onur Ayan, Kishor Chandra Joshi, Xueli An',
                paper: 'Tool Use as Action: Towards Agentic Control in Mobile Core Networks',
                venue: 'Accepted for presentation at IEEE PIMRC 2026 (Track 4), Singapore.',
                status: 'Accepted',
                link: 'https://arxiv.org/abs/2605.02811',
            },
            {
                id: 5,
                authors: 'Sicong Ye, Ming Xiao, Deyou Zhang, Chao Ren, Mikael Skoglund, Marco Di Renzo',
                paper: 'Fluid Antenna Systems Empowered Integrated Communication and Over-the-Air Computation',
                venue: 'IEEE Transactions on Communications, vol. 74, pp. 9970-9984, 2026, DOI:10.1109/TCOMM.2026.3698822.',
                status: 'Published',
                link: 'https://ieeexplore.ieee.org/document/11543358',
            },
            {
                id: 6,
                authors: 'Askin Altinoklu and Leila Musavian',
                paper: 'Lorentzian-Constrained Holographic Beamforming Optimization in Multi-User Networks With Dynamic Metasurface Antennas',
                venue: 'IEEE Transactions on Wireless Communications, vol. 25, pp. 10225–10240, 2026, DOI:10.1109/TWC.2026.3651852.',
                status: 'Published',
                link: 'https://ieeexplore.ieee.org/document/11353391',
            },
            {
                id: 7,
                authors: 'Askin Altinoklu and Leila Musavian',
                paper: 'DMA-Aided MU-MISO Systems for Power Splitting SWIPT via Lorentzian-Constrained Holography',
                venue: '2026 EuCNC/6G Summit, Malaga, Spain, June 2026.',
                status: 'Published',
                link: 'https://arxiv.org/abs/2511.08125',
            },
        ],
    },
    {
        title: '2025',
        papers: [
            {
                id: 8,
                authors: 'Ishtiaque Ahmed, Yingzhuo Sun, Jingwen Fu, Alper Kose, Leila Musavian, Ming Xiao, Berna Ozbek',
                paper: 'Semantic Communications in 6G: Coexistence, Multiple Access, and Satellite Networks',
                venue: 'IEEE Communications Standards Magazine, vol. 9, no. 4, pp. 58-64, Dec. 2025, DOI:10.1109/MCOMSTD.2025.3592327.',
                status: 'Published',
                link: 'https://ieeexplore.ieee.org/document/11095746',
            },
            {
                id: 9,
                authors: 'Ishtiaque Ahmed and Leila Musavian',
                paper: 'Hybrid NOMA Assisted Heterogeneous Semantic and Bit Users Communication',
                venue: 'IEEE 36th International Symposium on Personal, Indoor and Mobile Radio Communications (PIMRC), Istanbul, Türkiye, Sept. 2025, pp. 1-7, DOI:10.1109/PIMRC62392.2025.11275377.',
                status: 'Published',
                link: 'https://ieeexplore.ieee.org/document/11275377',
            },
            {
                id: 10,
                authors: 'Onur Ayan, Jiping Luo, Xueli An, Nikolaos Pappas',
                paper: 'Age-Aware CSI Acquisition of a Finite-State Markovian Channel',
                venue: 'IEEE 36th International Symposium on Personal, Indoor and Mobile Radio Communications (PIMRC), Istanbul, Türkiye, Sept. 2025, pp.1–6, DOI:10.1109/PIMRC62392.2025.11275172.',
                status: 'Published',
                link: 'https://ieeexplore.ieee.org/document/11275172',
            },
            {
                id: 11,
                authors: 'Akshay Mohan Nair, Shahid Mumtaz, Charalampos C. Tsimenidis, Faiyaz Doctor, Charalampos Karyotis, Rahat Iqbal',
                paper: 'Quantum Enabled Temporal Power Smoothing in User Equipment-Radio Unit Allocation for Wireless Systems',
                venue: 'IEEE 36th International Symposium on Personal, Indoor and Mobile Radio Communications (PIMRC), Istanbul, Türkiye, Sept. 2025, pp.1–7, DOI:10.1109/PIMRC62392.2025.11274701.',
                status: 'Published',
                link: 'https://ieeexplore.ieee.org/document/11274701',
            },
            {
                id: 12,
                authors: 'Askin Altinoklu and Leila Musavian',
                paper: 'Investigation of Holographic Beamforming via Dynamic Metasurface Antennas in QoS Guaranteed Power Efficient Networks',
                venue: '2025 Joint European Conference on Networks and Communications & 6G Summit (EuCNC/6G Summit), Poznan, Poland, June 2025, pp.542–547, DOI:10.1109/EuCNC/6GSummit63408.2025.11036928.',
                status: 'Published',
                link: 'https://ieeexplore.ieee.org/document/11036928',
            },
            {
                id: 13,
                authors: 'Yingzhuo Sun, Yulan Gao, Ming Xiao, Antoine Honoré',
                paper: 'Optimizing Satellite Selection and User Association in Multi-Orbit Satellite Constellations',
                venue: 'IEEE International Conference on Communications, Montreal, QC, Canada, 2025, pp.4185-4190, DOI:10.1109/ICC52391.2025.11161861.',
                status: 'Published',
                link: 'https://ieeexplore.ieee.org/document/11161861',
            },
            {
                id: 14,
                authors: 'Babak Azkaei, Kishor Joshi, George Exarchakos',
                paper: 'Machine Learning-Driven Anomaly Detection for 5G O-RAN Performance Metrics',
                venue: 'IEEE Conference on Computer Communications Workshops (INFOCOM WKSHPS), London, UK, May 2025, pp. 1-6, DOI:10.1109/INFOCOMWKSHPS65812.2025.11152997.',
                status: 'Published',
                link: 'https://ieeexplore.ieee.org/document/11152997',
            },
            {
                id: 15,
                authors: 'Ayesha Jadoon, Hao Ran Chi, Daniel Corujo, Rui L. Aguiar, Francisco J. Ferrão',
                paper: 'Latency and Energy Modeling of Blockchain-Digital Twin-Relied Edge Computing Task Scheduling',
                venue: '2025 IEEE International Conference on Consumer Technology-Europe (ICCT-Europe), Algarve, Portugal, DOI:10.1109/ICCT-Europe63283.2025.11157661.',
                status: 'Published',
                link: 'https://ieeexplore.ieee.org/document/11157661',
            },
            {
                id: 16,
                authors: 'Yi Zhou, Yutao Wang, Zheng Ma, Pingzhi Fan, Ming Xiao',
                paper: 'Physical Layer Authentication for UAV Communications Under Rayleigh and Rician Channels',
                venue: 'IEEE Transactions on Wireless Communications., vol. 24, no. 4, April 2025, DOI:10.1109/TWC.2024.3524210.',
                status: 'Published',
                link: 'https://ieeexplore.ieee.org/document/10834505/',
            },
        ],
    },
    {
        title: '2024',
        papers: [
            {
                id: 17,
                authors: 'Sicong Ye, Deyou Zhang, Ming Xiao, Mikael Skoglund',
                paper: 'Integrated Communication and Computation Empowered by Fluid Antenna Array',
                venue: '2024 IEEE International Workshop on Signal Processing Advances in Wireless Communications (SPAWC), Lucca, Italy, Sept. 2024, pp. 276-280, DOI:10.1109/SPAWC60668.2024.10694601.',
                status: 'Published',
                link: 'https://ieeexplore.ieee.org/document/10694601',
            },
            {
                id: 18,
                authors: 'Sicong Ye, Ming Xiao, Man-Wai Kwan, Zheng Ma, Yongming Huang, George Karagiannidis',
                paper: 'Extremely Large Aperture Array (ELAA) Communications: Foundations, Research Advances and Challenges',
                venue: 'IEEE Open Journal of the Communications Society, vol.5, pp.7075–7120, 2024, DOI:10.1109/OJCOMS.2024.3486172.',
                status: 'Published',
                link: 'https://ieeexplore.ieee.org/document/10734395',
            },
            {
                id: 19,
                authors: 'Cheng Zeng, Jun-Bo Wang, Ming Xiao, Changfeng Ding, Yijian Chen, Hongkang Yu',
                paper: 'Task-Oriented Semantic Communication over Rate Splitting Enabled Wireless Control Systems for URLLC Services',
                venue: 'IEEE Transactions on Communications, vol. 72, no. 2, Feb. 2024, DOI:10.1109/TCOMM.2023.3325901.',
                status: 'Published',
                link: 'https://ieeexplore.ieee.org/document/10287956',
            },
        ],
    },
]

const deliverablesList = [
    {
        no: 'D3.1',
        title: 'SCION use case scenarios',
        wp: 'WP3',
        partner: 'HWDU',
        type: 'R – Document, report',
        month: '18',
        link: '/FinalDeliverables/D3.1.pdf',
    },
    {
        no: 'D3.2',
        title: 'SCION architecture and design specification',
        wp: 'WP3',
        partner: 'HWDU',
        type: 'R – Document, report',
        month: '40',
    },
    {
        no: 'D4.1',
        title: 'Design of Semantic Encoder and Decoder',
        wp: 'WP4',
        partner: 'KTH',
        type: 'R — Document, report',
        month: '30',
        link: '/FinalDeliverables/D4.1.pdf',
    },
    {
        no: 'D4.2',
        title: 'Joint optimized Shannon and Semantic encoder and decoder',
        wp: 'WP4',
        partner: 'KTH',
        type: 'R — Document, report',
        month: '40',
    },
    {
        no: 'D4.3',
        title: 'Optimal power splitting for simultaneous power and information transfer',
        wp: 'WP4',
        partner: 'KTH',
        type: 'R — Document, report',
        month: '42',
    },
    {
        no: 'D5.1',
        title: 'Digital Twin modeling for M2M use cases',
        wp: 'WP5',
        partner: 'DME',
        type: 'R — Document, report',
        month: '36',
        link: '/FinalDeliverables/D5.1.pdf',
    },
    {
        no: 'D5.2',
        title: 'AI-based Intelligent centre and decision modeling and optimization',
        wp: 'WP5',
        partner: 'DME',
        type: 'R — Document, report',
        month: '42',
    },
    {
        no: 'D5.3',
        title: 'Blockchain modeling and optimization for CPS- M2M',
        wp: 'WP5',
        partner: 'DME',
        type: 'R — Document, report',
        month: '42',
    },
    {
        no: 'D6.1',
        title: 'AoI approaches for Real-time Network Malfunction Forecast and Detection',
        wp: 'WP6',
        partner: 'TU/e',
        type: 'R — Document, report',
        month: '52',
    },
    {
        no: 'D6.2',
        title: 'Transfer learning to Forecast Faults based on Knowledge from Existing Network',
        wp: 'WP6',
        partner: 'TU/e',
        type: 'R — Document, report',
        month: '42',
    },
    {
        no: 'D6.3',
        title: 'Efficient Reconfigurable Mechanisms for Fault Recovery',
        wp: 'WP6',
        partner: 'TU/e',
        type: 'R — Document, report',
        month: '42',
    },
    {
        no: 'D7.1',
        title: 'System level simulator validation and evaluation',
        wp: 'WP7',
        partner: 'IRIS',
        type: 'R — Document, report',
        month: '36',
    },
    {
        no: 'D7.2',
        title: 'Demonstration of algorithm/protocol in HIL based testbed',
        wp: 'WP7',
        partner: 'IRIS',
        type: 'DEM — Demonstrator, pilot, prototype',
        month: '54',
    },
]

const presentationVideos = [
    {
        title: 'Lorentzian-Constrained Holographic Beamforming With Dynamic Metasurface Antennas',
        author: 'Askin Altinoklu',
        link: 'https://www.youtube.com/watch?v=gFpWgr3Nb2k',
    },
    {
        title: 'Cross-Network Fault Prediction Using Transfer Learning',
        author: 'Nooruddin',
        link: 'https://www.youtube.com/watch?v=A0ZJdbtBR78',
    },
    {
        title: 'Age of Information (AoI) Approaches for Real-Time Network Anomaly Detection',
        author: 'Zia Ul Islam Nasir',
        link: 'https://www.youtube.com/watch?v=La_7VopA5hI',
    },
    {
        title: 'Design of Semantic Encoder and Decoder',
        author: 'Ishtiaque Ahmed',
        link: 'https://www.youtube.com/watch?v=Kg55m-4Zixg',
    },
    {
        title: 'Fluid Antenna Systems (FAS) Empowered Integrated Communication and Over-the-Air Computation',
        author: 'Sicong Ye',
        link: 'https://www.youtube.com/watch?v=E-R3-t2Op0A',
    },
    {
        title: 'Reliable Performance Monitoring for Open AI-RAN',
        author: 'Babak Azkaei',
        link: 'https://www.youtube.com/watch?v=nmKyUV3btLc',
    },
    {
        title: 'Digital Twin for Edge Computing Task Offloading: Case Study of Healthcare',
        author: 'Ayesha Jadoon',
        link: 'https://www.youtube.com/watch?v=iAAxA0XimYE',
    },
    {
        title: 'Satellite Selection and Resource Allocation in Low-Earth-Orbit Satellite Networks',
        author: 'Yingzhuo Sun',
        link: 'https://www.youtube.com/watch?v=xDHqZFAhR68',
    },
]

const TabPanel = ({ children, value, index }) => {
    if (value !== index) return null
    return (
        <Box
            role="tabpanel"
            id={`dissemination-tabpanel-${index}`}
            aria-labelledby={`dissemination-tab-${index}`}
            sx={{ pt: 3 }}
        >
            {children}
        </Box>
    )
}

const PublicationsTable = ({ papers }) => (
    <TableContainer component={Paper} sx={{ mb: '24px' }}>
        <Table sx={{ minWidth: 650 }} aria-label="publications table">
            <TableHead>
                <TableRow sx={{ backgroundColor: '#f5f5f5' }}>
                    <TableCell sx={headCellSx}>#</TableCell>
                    <TableCell sx={headCellSx}>Authors</TableCell>
                    <TableCell sx={headCellSx}>Paper</TableCell>
                    <TableCell sx={headCellSx}>Venue / Status</TableCell>
                    <TableCell sx={headCellSx}>Status</TableCell>
                    <TableCell sx={headCellSx}>Link</TableCell>
                </TableRow>
            </TableHead>
            <TableBody>
                {papers.map((paper) => (
                    <TableRow
                        key={paper.id}
                        sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                    >
                        <TableCell component="th" scope="row" sx={cellSx}>
                            {paper.id}
                        </TableCell>
                        <TableCell sx={cellSx}>{paper.authors}</TableCell>
                        <TableCell sx={cellSx}>{paper.paper}</TableCell>
                        <TableCell
                            sx={{
                                ...cellSx,
                                fontSize: '13px',
                                fontStyle: 'italic',
                                color: '#555',
                            }}
                        >
                            {paper.venue}
                        </TableCell>
                        <TableCell
                            sx={{
                                ...cellSx,
                                color: statusColor(paper.status),
                            }}
                        >
                            {paper.status}
                        </TableCell>
                        <TableCell sx={cellSx}>
                            {paper.link && paper.link !== '#' ? (
                                <Link
                                    href={paper.link}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    sx={{
                                        color: '#1976d2',
                                        textDecoration: 'none',
                                        '&:hover': { textDecoration: 'underline' },
                                    }}
                                >
                                    View Paper
                                </Link>
                            ) : (
                                <Typography sx={{ fontSize: '14px', color: '#999' }}>-</Typography>
                            )}
                        </TableCell>
                    </TableRow>
                ))}
            </TableBody>
        </Table>
    </TableContainer>
)

const Dissemination = () => {
    const [tab, setTab] = useState(0)

    return (
        <AppLayout>
            <Box sx={{ borderBottom: 1, borderColor: 'divider', mb: 1 }}>
                <Tabs
                    value={tab}
                    onChange={(_, value) => setTab(value)}
                    variant="scrollable"
                    scrollButtons="auto"
                    aria-label="Dissemination tabs"
                    sx={{
                        '& .MuiTab-root': tabLabelSx,
                        '& .Mui-selected': { color: '#3139A9' },
                        '& .MuiTabs-indicator': { backgroundColor: '#3139A9' },
                    }}
                >
                    <Tab label="Publications" id="dissemination-tab-0" aria-controls="dissemination-tabpanel-0" />
                    <Tab label="Deliverables" id="dissemination-tab-1" aria-controls="dissemination-tabpanel-1" />
                    <Tab label="Presentation" id="dissemination-tab-2" aria-controls="dissemination-tabpanel-2" />
                </Tabs>
            </Box>

            <TabPanel value={tab} index={0}>
                {publicationSections.map((section) => (
                    <Box key={section.title}>
                        <Typography
                            sx={{
                                fontFamily: 'Poppins-Semibold',
                                fontSize: '18px',
                                lineHeight: '22px',
                                color: '#222',
                                mb: '12px',
                                textAlign: { xs: 'center', md: 'left' },
                            }}
                        >
                            {section.title}
                        </Typography>
                        <PublicationsTable papers={section.papers} />
                    </Box>
                ))}
            </TabPanel>

            <TabPanel value={tab} index={1}>
                <TableContainer component={Paper} sx={{ mb: '50px' }}>
                    <Table sx={{ minWidth: 650 }} aria-label="deliverables table">
                        <TableHead>
                            <TableRow sx={{ backgroundColor: '#f5f5f5' }}>
                                <TableCell sx={headCellSx}>No</TableCell>
                                <TableCell sx={headCellSx}>Deliverable</TableCell>
                                <TableCell sx={headCellSx}>WP No</TableCell>
                                <TableCell sx={headCellSx}>Partner</TableCell>
                                <TableCell sx={headCellSx}>Type</TableCell>
                                <TableCell sx={headCellSx}>Month</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {deliverablesList.map((item) => (
                                <TableRow
                                    key={item.no}
                                    sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                                >
                                    <TableCell component="th" scope="row" sx={cellSx}>
                                        {item.no}
                                    </TableCell>
                                    <TableCell sx={cellSx}>
                                        {item.link ? (
                                            <Link
                                                href={item.link}
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                sx={{
                                                    display: 'inline-flex',
                                                    alignItems: 'flex-start',
                                                    gap: 0.75,
                                                    color: '#1565c0',
                                                    fontFamily: 'Poppins-Semibold',
                                                    fontWeight: 600,
                                                    textDecoration: 'underline',
                                                    textUnderlineOffset: '3px',
                                                    '&:hover': {
                                                        color: '#0d47a1',
                                                        textDecorationThickness: '2px',
                                                    },
                                                }}
                                            >
                                                <PictureAsPdfIcon sx={{ fontSize: 18, color: '#d32f2f', flexShrink: 0 }} />
                                                <Box component="span">{item.title}</Box>
                                                <Box
                                                    component="span"
                                                    sx={{
                                                        ml: 0.5,
                                                        px: 0.75,
                                                        py: 0.15,
                                                        borderRadius: '4px',
                                                        backgroundColor: '#e3f2fd',
                                                        color: '#1565c0',
                                                        fontFamily: 'Poppins-Semibold',
                                                        fontSize: '11px',
                                                        lineHeight: 1.4,
                                                        whiteSpace: 'nowrap',
                                                    }}
                                                >
                                                    PDF ↓
                                                </Box>
                                            </Link>
                                        ) : (
                                            item.title
                                        )}
                                    </TableCell>
                                    <TableCell sx={cellSx}>{item.wp}</TableCell>
                                    <TableCell sx={cellSx}>{item.partner}</TableCell>
                                    <TableCell sx={cellSx}>{item.type}</TableCell>
                                    <TableCell sx={cellSx}>{item.month}</TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>
            </TabPanel>

            <TabPanel value={tab} index={2}>
                <Typography
                    sx={{
                        fontFamily: 'Poppins-Semibold',
                        fontSize: '18px',
                        lineHeight: '22px',
                        color: '#222',
                        mb: '12px',
                        textAlign: { xs: 'center', md: 'left' },
                    }}
                >
                    Videos for Industrial Dissemination Day
                </Typography>

                <List sx={{ mb: 4, py: 0 }}>
                    {presentationVideos.map((video) => (
                        <ListItem
                            key={video.link}
                            sx={{
                                display: 'list-item',
                                listStyleType: 'disc',
                                ml: 3,
                                px: 0,
                                py: 0.75,
                            }}
                        >
                            <ListItemText
                                primary={
                                    <Typography sx={{ ...cellSx, color: '#222' }}>
                                        “{video.title}” by {video.author}
                                    </Typography>
                                }
                                secondary={
                                    <Link
                                        href={video.link}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        sx={{
                                            color: '#1976d2',
                                            textDecoration: 'none',
                                            fontFamily: 'Poppins-Regular',
                                            fontSize: '14px',
                                            wordBreak: 'break-all',
                                            '&:hover': { textDecoration: 'underline' },
                                        }}
                                    >
                                        {video.link}
                                    </Link>
                                }
                            />
                        </ListItem>
                    ))}
                </List>
            </TabPanel>
        </AppLayout>
    )
}

export default Dissemination
